import { Component, OnDestroy, OnInit } from '@angular/core';

import { IPlanSummaryProgress, IPlanSummaryTotals } from '../../../models/PlanSummary';
import { AppService } from '../../../services/app.service';
import { PlanSummaryService } from '../../../services/plan-summary.service';
import { getCurrentRequest } from '../plan-summary.component';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-plan-summary-totals',
    templateUrl: './plan-summary-totals.component.html',
    styleUrls: ['../plan-summary.component.scss']
})
export class PlanSummaryTotalsComponent implements OnInit, OnDestroy {
    constructor(
        private app: AppService,
        private service: PlanSummaryService
    ) { }

    data: IPlanSummaryProgress;
    groups: {
        name: string,
        totals: IPlanSummaryTotals[]
    }[] = [];

    private requestParamsSub: Subscription;

    ngOnInit() {
        this.requestParamsSub = getCurrentRequest().subscribe(req => {
            this.app.addLoading(this.service.getTotals(req.params)).subscribe(data => {
                this.data = data;

                this.groups = [
                    { name: 'Current', totals: this.data.Current },
                    { name: 'Overall', totals: this.data.Overall }
                ];
            });
        });
    }

    ngOnDestroy() {
        this.requestParamsSub?.unsubscribe();
    }
}
